DistributionBarChart = (function () {
    'use strict';
    var DistributionBarChart = function (container, config) {
        this.container = container;
        this.config = {
            attribute: config.attribute,
            title: config.title || "",
            marker: config.marker || null,
            sort: config.sort || false,
            ticksuffix: config.ticksuffix || null
        };
    };

    DistributionBarChart.prototype.setData = function (data) {
        if (!data || data.length == 0) {
            return;
        }
        this.data = this.transformData(data, this.config.attribute);
        this.renderChart(data);
    };

    DistributionBarChart.prototype.transformData = function (data, attribute) {
        var self = this;
        var result = _.chain(data)
            .countBy(function (item) {
                return item[attribute];
            })
            .toPairs();
        if (this.config.sort) {
            result = result.sortBy(function (item) {
                return parseInt(item[0]);
            })
        }
        return result
            .fromPairs()
            .value();
    };

    DistributionBarChart.prototype.transformLabel = function (val) {
        return val;
    };

    DistributionBarChart.prototype.renderChart = function () {
        var trace = {
            y: _.values(this.data),
            x: _.keys(this.data),
            dx: 1,
            type: 'bar',
        };
        Plotly.newPlot(this.container,
            [trace],
            {
                title: this.config.title || null,
                xaxis: {
                    type: 'category',
                    ticksuffix: this.config.ticksuffix
                }
            });
    };

    DistributionBarChart.prototype.clearChart = function (data) {
        Plotly.purge(this.container)
    };

    return DistributionBarChart;
})();